import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import Toast from '../../../../core/components/core/Util/Toast/Toast';

function List() {

    const pathFrontEnd = '/demonstrativetypes/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}demonstrativetypes/delete`,
        endpoint: config.endpoints.backend + 'demonstrativetypes/getalllist'
    }

    let list = {
        labelTitle: 'Lista de Tipos de Demonstrativo',
        labelTitleButtonAdd: 'Incluir novo tipo',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        columns: [
            {
                name: 'name',
                label: 'Nome do tipo de demonstrativo'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
